export default {
  'profile.verified': '已驗證',
  'profile.unverified': '未驗證',
  'profile.refresh': '刷新',
  'profile.name': '姓名',
  'profile.getCode': '獲取驗證碼',
  'profile.codeTip': '請輸入驗證碼',
  'profile.verifyCode': '驗證碼',
  'profile.phoneChange': '手機號碼修改',
  'profile.checkPhone': '驗證當前手機',
  'profile.bindNewPhone': '綁定新手機',
  'profile.nuxt': '下一步',
  'profile.changeSuccess': '修改成功！',
  'profile.firstNameTip': '請輸入名字',
  'profile.lastNameTip': '請輸入姓氏',
  'profile.emailChange': '郵件修改',
  'profile.checkEmail': '驗證當前郵箱',
  'profile.bindNewEmail': '綁定新郵箱',
  'profile.bindEmailTip': '請輸入新郵箱',
  'app.profile': '個人中心',
  'app.profile.account': '帳戶設定',
  'app.profile.account.save': '儲存',
  'app.profile.account.account': '登入帳號',
  'app.profile.account.password': '登入密碼',
  'app.profile.account.password.update': '最後一次密碼更新時間',
  'app.profile.account.password.reset': '重設密碼',
  'app.profile.account.name.first': '名字',
  'app.profile.account.name.last': '姓氏',
  'app.profile.account.name.phone': '手機號碼',
  'app.profile.account.name.phone.tip':
    '我們可能會使用此電話號碼，向您傳送安全事件、帳單和業務預警等資訊',
  'app.profile.account.name.url': '回呼地址',
  'app.profile.account.name.urlTip':
    '必須以http:// 或者 https://開頭，不支持自定義端口，不支持IP為10.0.0.0/8，172.16.0.0/12，192.168.0.0/16 私有網段。',
  'app.profile.account.name.verification': '校驗',
  'app.profile.account.name.verification.tip[1]': '成功',
  'app.profile.account.name.verification.tip[2]': '失敗',
  'app.profile.developer': '開發者信息',
  'app.profile.developer.remark': '僅限於 API 調用時使用',
  'app.profile.developer.label[1]': '開發者標識（DevKey）',
  'app.profile.developer.label[2]': 'API DevSecret',
  'app.profile.developer.copy': '查看並複制',
  'app.profile.developer.reset': '重置',
  'app.profile.developer.reset.tip': '提示', //新加的
  'app.profile.developer.reset.tip.content':
    'Dev Secret 變更將影響 API 推送，需要調用方更改調用代碼', //新加的
  'app.profile.developer.reset.tip.sure': '確認重置', //新加的
  'app.profile.developer.reset.tip.cancel': '再考慮下', //新加的
  'app.profile.developer.copy.success': '複製成功',
  'app.profile.developer.reset.success': '重置成功',
  'app.profile.single': '單點登入',
  'app.profile.single.tip[1]': '提高安全性，降低帳戶遭盜竊的風險',
  'app.profile.single.tip[2]': '避免企業員工因使用不同業務系統而疲於建立帳號',
  'app.profile.single.tip[3]': '使用企業內部員工帳號系統，簡化身份驗證',
  'app.profile.single.enable': '聯繫銷售',
  'app.profile.single.title': '業務請求',
  'app.profile.single.subject': '主題',
  'app.profile.single.subject.value': '為我得賬戶啟用單點登錄',
  'app.profile.single.content': '妳好，我想啓用單壹登錄。請向我提供援助。謝謝。',
  'app.profile.single.subject.validator': '請輸入主題',
  'app.profile.single.subject.doc': '為我的帳戶啟用單點登入',
  'app.profile.single.message': '訊息',
  'app.profile.single.message.validator': '請輸入訊息',
  'app.profile.single.submit': '提交',
  'app.profile.single.submit.success': '提交成功，待管理人員郵件回復',
  'app.profile.account.deletion': '刪除我的帳戶',
  'app.profile.account.deletion.warn':
    '刪除帳戶操作後，EngageLab 將永久刪除您的帳號，以及帳號相關所有用戶資訊、業務資訊和訂單資訊等資料。一旦刪除，您將無法恢復帳戶和資料',
  'app.profile.account.deletion.action': '刪除我的帳戶',
  'app.profile.delete.title': '刪除帳號',
  'app.profile.delete.content':
    '警告！刪除帳號操作為不可逆轉，將永久刪除該帳號內的用戶、業務、餘額、帳單、訂單和權益等資料和資訊，同時停止所有相關服務。',
  'app.profile.delete.content2':
    '或許您可以透過「修改帳戶電子郵件地址」或「為組織成員授予角色權限設定」的方式來達成目的，建議您在非必要時盡量保留帳戶的使用。',
  'app.profile.delete.warn': '要刪除帳戶，該帳戶必須無待補繳的帳單，否則將無法刪除！',
  'app.profile.delete.cancel': '取消',
  'app.profile.delete.next': '下一步',
  'app.profile.delete.delete': '刪除',
  'app.profile.delete.confirm': '確認刪除帳號',
  'app.profile.delete.confirm.content':
    '您提交的刪除帳戶申請生效前，我們將進行下列驗證事宜，以確保您的帳號安全。請檢查電子郵件中的驗證碼資訊',
  'app.profile.delete.confirm.send': '傳送驗證',
  'app.profile.delete.confirm.send.resend': '重新傳送驗證',
  'app.profile.delete.confirm.resend': '重新傳送',
  'app.profile.delete.confirm.rule': '請輸入正確驗證碼',
  'app.profile.delete.confirm.code.title': '郵箱驗證碼',
  'app.profile.delete.confirm.code.desc':
    '為驗證身份，確保帳戶安全，請提供您郵箱 currentAccount.email 收到的驗證碼',
  'app.profile.delete.confirm.reason.title': '刪除原因',
  'app.profile.delete.confirm.reason.desc': '這些信息能幫助我們改進產品',
  'app.profile.delete.confirm.reason.placeholder': '選擇原因',
  'app.profile.delete.confirm.reason.select1': '刪除測試帳戶',
  'app.profile.delete.confirm.reason.select2': '更換使用其他帳戶',
  'app.profile.delete.confirm.reason.select3': '不再有興趣使用 EngageLab 服務',
  'app.profile.delete.confirm.reason.select4': '其他',
  'app.profile.reset.title': '重設密碼',
  'app.profile.reset.password.old': '舊密碼',
  'app.profile.reset.password.old.placeholder': '請輸入舊密碼',
  'app.profile.reset.password.new': '新密碼',
  'app.profile.reset.password.new.placeholder': '請輸入新密碼',
  'app.profile.reset.password.confirm': '確認密碼',
  'app.profile.reset.password.confirm.placeholder': '請確認新密碼',
  'app.profile.reset.cancel': '取消',
  'app.profile.reset.confirm': '確認',
  'app.profile.rule.blank': '內容不得為空',
  'app.profile.reset.new.rule[0]': '包含至少 8 個字元',
  'app.profile.reset.new.rule[1]': '不符合包含小寫字母 (a-z) 和大寫字母 (A-Z) 的條件',
  'app.profile.reset.new.rule[2]': '符合至少包含一個數字 (0-9) 或一個符號的條件',
  'app.profile.reset.confrim.rule[0]': '兩次輸入密碼不一致',
  'app.profile.reset.old.rule[0]': '密碼輸入不正確',
  'app.profile.reset.success': '密碼修改成功',
  'app.profile.aws.title': 'Amazon 訂單',
  'app.profile.aws.subtitle':
    '您的 EngageLab 帳戶已與 Amazon 帳戶綁定，您可以在此將 Amazon 訂單與相應的 EngageLab 服務關聯，從而獲得 EngageLab VIP 權益。',
  'app.profile.aws.account': 'Amazon 帳戶 ID',
  'app.profile.aws.btn': '管理訂單',
  'app.profile.human.code.loadingTip': '請稍候…',
  'app.profile.human.code.placeholder': '請輸入驗證碼',
  'app.profile.human.check.tip': '請先完成人機驗證。',
  'app.profile.human.check.error': '人機驗證失敗，請重試。',
  'app.profile.sso.title': 'SSO 配置服務',
  // SSO Empty
  'app.profile.sso.empty.title': '您尚未配置任何 SSO',
  'app.profile.sso.empty.description':
    '配置 SSO 後，配置組織下用戶、成員、和業務合作夥伴能夠安全地訪問他們完成最佳工作所需的一切，以及直觀的登錄體驗。',
  'app.profile.sso.empty.configure': '配置 SSO',
  'app.profile.sso.empty.title2': '暫無 SSO 權益',
  'app.profile.sso.empty.description2':
    '您的組織暫未開通 SSO 權益，請聯繫商務開通權益後再進行配置。',
  'app.profile.sso.empty.contact': '立即聯繫',
  'app.profile.sso.empty.contact.content': '我想創建 SSO',
  // SSO List
  'app.profile.sso.list.configure': '配置 SSO',
  'app.profile.sso.list.authorizedOrg': '已授權組織',
  'app.profile.sso.list.benefitStatus': '權益狀態',
  'app.profile.sso.list.authorizedOrgLong':
    '已授權組織已授權組織已授權組織已授權組織已授權組織已授權組織已授權組織',
  'app.profile.sso.list.edit': '編輯',
  'app.profile.sso.list.authorize': '授權',
  'app.profile.sso.list.delete': '刪除',
  'app.profile.sso.list.deleteConfirm.title': '確認刪除 SSO 服務 {name}？',
  'app.profile.sso.list.deleteConfirm.content':
    '刪除 SSO 服務後，該服務授權的組織將不再支持 SSO 登錄，且登錄鏈接將失效，並收到一封停止使用 SSO 登錄的郵件。',
  'app.profile.sso.list.deleteSuccess': '刪除成功',
  'app.profile.sso.list.confirm.modify.title': '確認修改 SSO 服務授權？',
  'app.profile.sso.list.confirm.modify.content.add':
    '新增授權的組織，所有組織成員將收到一封提醒郵件，提供了本 SSO 服務的登錄鏈接，要求他們使用本 SSO 服務進行登錄。',
  'app.profile.sso.list.confirm.modify.content.remove':
    '取消授權的組織，所有組織成員將收到一封提醒郵件，告知他們無法再使用本 SSO 服務登錄，並提供了組織支持的其他登錄方式。',
  // SSO Option
  'app.profile.sso.option.step1': 'IdP 配置',
  'app.profile.sso.option.step2': '數據返回',
  'app.profile.sso.option.step3': '授權組織',
  'app.profile.sso.option.step4': '驗證',
  'app.profile.sso.option.continue': '繼續',
  'app.profile.sso.option.prev': '上一步',
  'app.profile.sso.option.back': '返回',
  'app.profile.sso.option.submit': '提交',
  'app.profile.sso.option.save': '保存並驗證',

  // SSO Step 1
  'app.profile.sso.step1.title': '在 IdP 中配置 Engagelab',
  'app.profile.sso.step1.description':
    '單點登錄單點登錄（SSO），您首先需要將 Engagelab 添加為身份提供商（IdP）中的應用程序。請聯繫您的組織的 IdP 管理員以在您的帳戶下添加屬配置 IdP 的應用程序設',
  'app.profile.sso.step1.serviceType': 'SSO 服務類型',
  'app.profile.sso.step1.guideText': '可使用使用以下令牌唯一您組織的 IdP 管理員進行協作：',
  'app.profile.sso.step1.copy': '複製',
  'app.profile.sso.step1.confirmTip': '該確認 Engagelab 應用程序的信息已在您的 IdP 中更新',
  'app.profile.sso.step1.infoText': `I am setting up SSO for Engagelab, and I need assistance setting up Engagelab as an application in our identity provider.

Here is the information that Engagelab provides for setting up the application:

Entity ID:643e77b90116033eef7e325b001
ACS URL: https://www.engagelab.com/accounts/signin/callback?connection=643e77b90116033eef7e325b001
Login URL：https://www.engagelab.com/accounts/signin-sso
Logout URL：https://www.engagelab.com/api/console/account/login/out

Once the Engagelab application is set up in our IdP, please send me the following information from the IdP to complete SSO setup in Engagelab:

X.509 certificate:`,
  // SSO Step 2
  'app.profile.sso.step2.title': '輸入 IdP 返回的數據',
  'app.profile.sso.step2.description':
    '現在您已經在身份提供商中設置了 Engagelab 應用程序並擁有必要的信息，請將 IdP 應用程序的以下信息在此輸入。',
  'app.profile.sso.step2.serviceName': 'SSO 服務的名稱',
  'app.profile.sso.step2.serviceNamePlaceholder':
    '請輸入一個描述 SSO 服務的名稱，便於服務列表進行區分',
  'app.profile.sso.step2.certificate': 'x509 Certificate',
  'app.profile.sso.step2.certificatePlaceholder': '請將 base64 證書的內容複製在此處',
  'app.profile.sso.step2.loginUrl': 'IdP Login URL',
  'app.profile.sso.step2.loginUrlPlaceholder': '請輸入身份提供商的登錄 URL',
  'app.profile.sso.step2.logoutUrl': 'IdP Logout URL',
  'app.profile.sso.step2.logoutUrlPlaceholder': '請輸入身份提供商的註銷 URL',
  // SSO Step 3
  'app.profile.sso.step3.title': '將 IdP 授權給組織',
  'app.profile.sso.step3.description':
    '請將該 SSO 服務授權給您創建的組織，組織的成員可以使用所配置的身份提供商 （IdP）登錄 Engagelab。',
  'app.profile.sso.step3.selectOrg': '選擇組織',
  'app.profile.sso.step3.contactBusiness': '聯繫商務',
  'app.profile.sso.step3.noBenefitTip': '當前組織無權益，不可用',
  'app.profile.sso.step3.saveConfirm.title':
    '為組織配置 SSO 服務後，組織成員必須使用 SSO 登錄才能訪問該組織',
  'app.profile.sso.step3.saveConfirm.content':
    '保存後，所有組織成員將被退出登錄，並收到一封要求使用 SSO 登錄的郵件',
  'app.profile.sso.step3.canAuthorize': '可授權',
  'app.profile.sso.step3.numLimit.title': '受限',
  'app.profile.sso.step3.numLimit.tip': 'SSO協議數量超限',
  'app.profile.sso.step3.numLimit.text': 'SSO協議數量超限，不可用',
  'app.profile.sso.step3.noBenefit.title': '無權益',
  'app.profile.sso.step3.noBenefit.text': '當前組織無權益，不可用',
  'app.profile.sso.step3.column.orgId': '組織ID',
  'app.profile.sso.step3.column.orgName': '組織名稱',
  'app.profile.sso.step3.column.memberNum': '成員數量',
  'app.profile.sso.step3.column.authStatus': '授權狀態',
  'app.profile.sso.step3.column.timeZone': '時區',
  'app.profile.sso.step3.column.createTime': '創建時間',
  // SSO Step 4
  'app.profile.sso.step4.title': '驗證 SSO 服務',
  'app.profile.sso.step4.description':
    '現在您已完成 SSO 的所有配置，最後請確認用戶可以使用 SSO 成功登錄 Engagelab。',
  'app.profile.sso.step4.loginUrl': 'SSO 登錄 URL',
  'app.profile.sso.step4.tip': '提示',
  'app.profile.sso.step4.tipContent':
    '通過該鏈接登錄的帳號，若在組織內沒有任何角色，將自動授予 Default 角色。您可以在成員加入後修改他的角色。',
  'app.profile.sso.step4.notice': '請注意',
  'app.profile.sso.step4.noticeContent':
    '通過該鏈接登錄的帳號，若在組織內沒有任何角色，將自動授予 Default 角色。您可以在成員加入後修改他的角色。',
  'app.profile.sso.step4.needHelp': '仍需要幫助嗎',
  'app.profile.sso.step4.helpContent': '無法登錄成功?請參照文檔說明進行檢查。',
  'app.profile.sso.step4.viewDoc': '查看文檔',
  // SSO Details
  'app.profile.sso.details.title': 'SSO 服務詳情',
  'app.profile.sso.details.serviceDetails': 'SSO 服務詳情',
  'app.profile.sso.details.name': '名稱',
  'app.profile.sso.details.namePlaceholder': '請輸入名稱',
  'app.profile.sso.details.type': '類型',
  'app.profile.sso.details.typePlaceholder': '請輸入類型',
  'app.profile.sso.details.loginLink': 'SSO 登錄鏈接',
  'app.profile.sso.details.loginLinkPlaceholder': '請輸入SSO 登錄鏈接',
  'app.profile.sso.details.spConfig': 'SP 配置信息',
  'app.profile.sso.details.entityIdPlaceholder': '請輸入Entity ID',
  'app.profile.sso.details.idpConfig': 'IDP 配置信息',
  'app.profile.sso.details.certificatePlaceholder': '請輸入X.509證書',
  'app.profile.sso.details.loginUrlPlaceholder': '請輸入Login URL',
  'app.profile.sso.details.logoutUrlPlaceholder': '請輸入Logout URL',
  'app.profile.sso.details.urlPlaceholder': '請輸入正確的URL',
  'app.profile.sso.details.certificateExpiry': '證書將於 {date} 到期',
  'app.profile.sso.details.cancel': '取消',
  'app.profile.sso.details.save': '保存',
  'app.profile.sso.details.edit': '編輯',
  // SSO OrgSelect
  'app.profile.sso.orgSelect.title': '授權組織',
  'app.profile.sso.orgSelect.availableOrg': '可選組織',
  'app.profile.sso.orgSelect.serviceExpired': '服務權益到期，不可用',
  'app.profile.sso.orgSelect.contactBusiness': '聯繫商務',
  'app.profile.sso.orgSelect.authorizedService': '已授權服務',
  'app.profile.sso.orgSelect.serviceNameLong':
    'SSO服務名稱服務名稱服務名稱服務名稱SSO服務名稱服務名稱服務名稱服務名稱SSO服務名稱服務名稱服務名稱服務名稱SSO服務名稱服務名稱服務名稱服務名稱',
  'app.profile.sso.orgSelect.selectedOrg': '已選組織',
  'app.profile.sso.orgSelect.noSelectedOrg': '暫無已選組織，請從左邊選擇組織',
  'app.profile.sso.orgSelect.noAvailable': '暫無可選組織',
  'app.profile.sso.orgSelect.authorized': '已授權',
  'app.profile.sso.orgSelect.cancel': '取消',
  'app.profile.sso.orgSelect.save': '保存',
  'app.profile.sso.orgSelect.canAuthorize': '可授權',
  'app.profile.sso.orgSelect.otherAuthorize': '其他授權',
  'app.profile.sso.orgSelect.noBenefit': '無權益',
  'app.profile.sso.orgSelect.saveSuccess': '保存成功',
  'app.profile.sso.list.ssoServiceName': 'SSO服務名稱',
  'app.profile.sso.list.ssoType': '類型',
  'app.profile.sso.list.ssoLoginUrl': '登錄鏈接',
  'app.profile.sso.list.authOrgList': '已授權組織',
  'app.profile.sso.authorized.organizations': '已授權組織',
  'app.profile.sso.benefit.status': '權益狀態',

  'app.sso.no.permission.title': '無此頁面訪問權限',
  'app.sso.no.permission.desc': '如需獲取訪問權限，請聯繫管理員',
  'app.sso.no.permission.logout': '退出登錄',
};
